// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__JfYO2","menuItem":"Navigation_menuItem__Qn9h6","active":"Navigation_active__f15XZ","cta":"Navigation_cta__2Aj5d"};